import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { useRouteParams } from 'src/hooks/useRouteParams';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { proposalRouteConfig } from '../../routes';

export const useEditProposalComment = ({
  commentId,
}: {
  commentId: string;
}) => {
  const { graphId, graphVariant } = useRouteParams(proposalRouteConfig);

  const [editComment] = useMutation<
    GraphQLTypes.ProposalCommentEditMutation,
    GraphQLTypes.ProposalCommentEditMutationVariables
  >(gql`
    mutation ProposalCommentEditMutation(
      $input: EditCommentInput!
      $graphId: ID!
      $graphVariant: String!
    ) {
      graph(id: $graphId) {
        variant(name: $graphVariant) {
          proposal {
            ... on ProposalMutation {
              editComment(input: $input) {
                ... on NotFoundError {
                  message
                }
                ... on ParentChangeProposalComment {
                  id
                  message
                  updatedAt
                }
                ... on ReplyChangeProposalComment {
                  id
                  message
                  updatedAt
                }
                ... on ParentGeneralProposalComment {
                  id
                  message
                  updatedAt
                }
                ... on ReplyGeneralProposalComment {
                  id
                  message
                  updatedAt
                }
                ... on PermissionError {
                  message
                }
                ... on ValidationError {
                  message
                }
              }
            }
          }
        }
      }
    }
  `);

  return {
    editComment: useCallback(
      async (message: string) => {
        return editComment({
          variables: {
            graphId,
            graphVariant,
            input: {
              id: commentId,
              message,
            },
          },
        });
      },
      [commentId, editComment, graphId, graphVariant],
    ),
  };
};
